var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reading-pen-index page-index"},[_c('Header'),_c('div',{staticClass:"reading-pen-main"},[_c('PageTop',{staticClass:"bg-gray",attrs:{"page":"reading-pen"}}),_c('ReadingPenInfo'),_c('ReadingPenDetail')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }